import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  getProductDetails: ({commit}, data) => {
    pointsMailApi.getProductDetails(data)
      .then(result => {
        commit(types.PRODUCT_DETAILS, result)
      })
  },
  purchaseProduct: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.purchaseProduct(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  getShooptingCardNum: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.getShooptingCardNum(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  addShoppingCartById: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.addShoppingCartById(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/store/actions.js